import React, { Component } from "react";

import { QuizObjectCardTable } from "../../../../store/modquiz/quiz_objects/quiz-object";
import { QuizObjectCardTableComponent } from "./CardTable";

interface MyProps {
    card_tables: Array<QuizObjectCardTable>;
    focusField: Function;
    blurField: (event: React.FocusEvent<HTMLInputElement>) => void;

}

function CardTableEditor
({ card_tables, focusField, blurField }: MyProps) {
    return (
        <div className="QuizObjectTables">
            {card_tables.length > 0 ? (<h3>Card Tables</h3>) : (<></>)}
            {card_tables.map((card_table, i) => {
                return (
                    <QuizObjectCardTableComponent
                        key={i}
                        card_table={card_table}
                        focusField={focusField}
                        blurField={blurField}                    
                    />
                );
            })}
        </div>
    );
}

export default CardTableEditor;
